<template>
  <b-modal id="fub-integration" title="Follow Up Boss" @shown="checkComplete" @hidden="api_key = null" hide-footer>
    <p class="text-center"><img src="/img/integrations/fub-logo.png" />
    <div v-if="step == 1">
      <p>Integrating FUB will give you the ability to search for your FUB clients and to automate the import of deals from FUB.</p>
      <strong>Step To Retreive API Key:</strong>
      <p>{{ steps.join(" &raquo; ") }}</p>

      <div v-if="integration.masked_key" class="mb-3">
          <h5>Current Key</h5>
          <small>{{ integration.masked_key }}</small>
          <p><small>To update your API Key enter a new key below.</small></p>
      </div>
      <b-form @submit.prevent="submit">
        <b-form-group>
          <label class="form-control-label" label-for="api_key">API Key</label>
          <b-form-input v-model="api_key" required></b-form-input>
        </b-form-group>
        <div class="text-right">
          <b-button variant="outline-danger" @click="close">Close</b-button>
          <b-button variant="outline-success" type="submit">Save API Key</b-button>
        </div>
      </b-form>
    </div>
    <div v-if="step == 2">
      <div v-if="!integration.completed">
        <strong>Complete Integration</strong>
        <p class="small">When you complete the integration ClarityNOW will automatically add custom Deal Fields and Webhooks to your FUB instance. We use these custom fields to reduce the amount of input you have to put into ClarityNOW. Once a deal is created, updated, or deleted in FUB it will be imported into ClarityNOW automatically. You will then need to complete the rest of the transaction here in ClarityNOW</p>
        <div class="text-center">
          <b-button variant="outline-danger" @click="completeIntegration" :disabled="disabled">Complete Integration</b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

export default {
  props: {
    userRoute: null,
    integration: null
  },
  data() {
    return {
      step: 0,
      api_key: null,
      steps: ['Log into FUB', 'Admin', 'More', 'API', 'Create API Key'],
      disabled: false,
    }
  },
  methods: {
    submit() {
      if (this.integration.id) {
        this.update();
      } else {
        this.store();
      }
    },
    async store(integration) {
      await axios.post(this.userRoute + "/integrations", {
        name: this.integration.name,
        api_key: this.api_key,
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.api_key = null;
          this.$emit('getIntegration');
          this.next();
        });
      })
      .catch(error => {
        // 
      });
    },
    async update() {
      await axios.patch(this.userRoute + "/integrations/" + this.integration.id, {
        id: this.integration.id,
        name: this.integration.name,
        api_key: this.api_key
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.api_key = null;
          this.$emit('getIntegration');
          this.close();
        });
      })
      .catch(error => {
        // 
      });
    },
    async completeIntegration() {
      this.disabled = true;

      await axios.post(this.userRoute + "/integrations/fub/complete-integration")
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 2000,
          icon: 'success'
        }).then(result => {
          this.$emit('getIntegration');
          this.close();
        });
      })
      .catch(error => {
        this.disabled = false;
      });
    },
    close() {
      this.$bvModal.hide('fub-integration');
    },
    next() {
      this.step = this.step + 1;
    },
    checkComplete() {
      if (this.integration.id && !this.integration.completed) {
        this.step = 2;
      } else {
        this.step = 1;
      }
    }
  }
};
</script>
<style lang="scss">
.modal-header .close {
  padding: 0.1rem 0.4rem;
}
</style>